import { DragEndEvent } from '@dnd-kit/core';
import React from 'react';
import { FilterOptions, FilterOrders } from '../../hooks/useFilters';
import { permissionsGroup } from '../priviledge/PriviledgeProvider';
import DynamicTableColumns from './components/DynamicTableColumns';
import { RowColorRules } from './components/MainTable';
import MainTableWaitColumnConfig from "./components/MainTableWaitColumnConfig";

export interface PaginationProps {
    pageCount: number,
    currentPage: number,
    pageSize: number,
    totalCount: number,
    handlePagination: Function,
    handlePerPage: Function,
}

export interface ActionConfig {
    label: string;
    permissions?: { group: permissionsGroup; permission: string };
    render: Function;
    hide?: boolean | Function;
}

interface CustomTableProps {
    id: string;
    data: any[];
    columnOrder?: string[];
    columnsNotShown?: string[];
    isLoading?: boolean;
    floatingHorizontalScrollbar?: boolean;
    viewFilters?: boolean;
    filters: FilterOptions;
    updateFilters?: Function;
    updateFilterOrder?: Function;
    defaultOrder?: FilterOrders | undefined;
    pagination?: boolean;
    paginationData?: PaginationProps;
    overrideColumns?: { key: string; columnNameKey?: string | null; permissions?: { group: permissionsGroup; permission: string }[]; render: Function; customHeader?: string | React.ReactNode | null; colHeaderClassName?: string | null; size?: number }[];
    additionalColumns?: { id: string; header: string; render: Function; enableSorting?: boolean }[];
    actions?: ActionConfig[];
    multiActions?: ActionConfig[];
    handleMultipleDelete?: Function;
    multiDeletePermission?: { action: string; group: permissionsGroup } | null;
    search?: boolean;
    filter?: boolean;
    toggleFilters?: Function;
    children?: React.ReactNode;
    largeTable?: boolean;
    columnsNoSortables?: any;
    isSortable?: boolean;
    addicionalButtons?: React.ReactNode;
    showId?: boolean;
    classNameTable?: string;
    divClassName?: string;
    headerTableClassName?: string;
    disabledIds?: string[] | null;
    customRowsBackgroundColors?: RowColorRules;
    footerRow?: (() => Record<string, any>) | null;
    renderRowDropdown?: (row: any) => Record<string, any> | null;
    showToggleButton?: boolean;
    onDragEnd?: (event: DragEndEvent) => void;
}

const CustomTable: React.FC<CustomTableProps> = (
    {
        id,
        data,
        columnOrder,
        columnsNotShown,
        isLoading,
        floatingHorizontalScrollbar = false,
        overrideColumns,
        additionalColumns,
        actions,
        viewFilters = true,
        multiActions,
        handleMultipleDelete,
        multiDeletePermission,
        filters,
        updateFilters,
        updateFilterOrder,
        defaultOrder,
        pagination = true,
        paginationData,
        search = true,
        filter = true,
        toggleFilters,
        children,
        largeTable = false,
        columnsNoSortables = [],
        isSortable = false,
        showId = false,
        addicionalButtons = null,
        classNameTable = '',
        divClassName = '',
        headerTableClassName = '',
        disabledIds = null,
        customRowsBackgroundColors = [],
        footerRow = null,
        renderRowDropdown,
        showToggleButton = true,
        onDragEnd,
    }
) => {

    const { configuredColumns } = DynamicTableColumns({
        id,
        data,
        columnsNotShown,
        overrideColumns,
        additionalColumns,
        actions,
        columnOrder,
        showId,
        disabledIds,
        hasDragAndDrop: !!onDragEnd
    });

    return (
        <>
            {configuredColumns !== null && (
                <MainTableWaitColumnConfig
                    id={id}
                    data={data}
                    defaultColumnConfig={configuredColumns}
                    filters={filters}
                    floatingHorizontalScrollbar={floatingHorizontalScrollbar}
                    multiActions={multiActions}
                    handleMultipleDelete={handleMultipleDelete}
                    multiDeletePermission={multiDeletePermission}
                    isLoading={isLoading}
                    viewFilters={viewFilters}
                    pagination={pagination}
                    paginationData={paginationData}
                    search={search}
                    defaultOrder={defaultOrder}
                    updateFilterOrder={updateFilterOrder}
                    updateFilters={updateFilters}
                    toggleFilters={toggleFilters}
                    filter={filter}
                    children={children}
                    largeTable={largeTable}
                    columnsNoSortables={columnsNoSortables}
                    isSortable={isSortable}
                    addicionalButtons={addicionalButtons}
                    classNameTable={classNameTable}
                    customRowsBackgroundColors={customRowsBackgroundColors}
                    disabledIds={disabledIds}
                    footerRow={footerRow}
                    renderRowDropdown={renderRowDropdown}
                    divClassName={divClassName}
                    headerTableClassName={headerTableClassName}
                    showToggleButton={showToggleButton}
                    onDragEnd={onDragEnd}
                />
            )}
        </>
    );
};

export default CustomTable;
